import { API } from '@/api';
import { axiosInstance } from '@/utils/fetcher';
import type { AxiosResponse } from 'axios';

export const getPreClaimsDispositionMethodListAPI = () => {
  return axiosInstance.request({
    url: `${API.PRECLAIM}/GetDispositionMethod`,
    method: 'get',
  });
};

export type PreClaimsDispositionMethodListResponse = {
  key: string; // 2A, 1, 2B
  value: string; // 'Disposal in Field', ...
}[];

export const fetchPreClaimsDispositionMethodList = async (): Promise<PreClaimsDispositionMethodListResponse> => {
  const response: AxiosResponse<PreClaimsDispositionMethodListResponse> = await getPreClaimsDispositionMethodListAPI();
  return response.data;
};
